// extracted by mini-css-extract-plugin
export default {"form":"fL0x8W","repeat-container":"vX5THj","label":"d9s80W"};